import { render, staticRenderFns } from "./AgentDetail.vue?vue&type=template&id=c9d8f702&scoped=true"
import script from "./AgentDetail.vue?vue&type=script&lang=js"
export * from "./AgentDetail.vue?vue&type=script&lang=js"
import style0 from "./AgentDetail.vue?vue&type=style&index=0&id=c9d8f702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d8f702",
  null
  
)

export default component.exports